import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categories: [],
  unities: [],
  list: [],
  lowList:[],
  outOfList:[],
  expiredList:[],
  stockMove : []

};

const productSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    getCategories: (state, action) => {
      state.categories = action.payload;
    },

    deleteCategory: (state, action) => {
      state.categories = state.categories.filter(
        (category) => category.id !== action.payload
      );
    },


    getUnities: (state, action) => {
      state.unities = action.payload;
    },

    deleteUnity: (state, action) => {
      state.unities = state.unities.filter(
        (unity) => unity.id !== action.payload
      );
    },

    getProduct: (state, action) => {
      state.list = action.payload;
    },

    getLowStock: (state, action) => {
      state.lowList = action.payload;
    },

    getOutOfStock: (state, action) => {
      state.outOfList = action.payload;
    },
    getExpiredList: (state, action) => {
      state.expiredList = action.payload;
    },
    destroyProductData: (state) => {
      state.categories = [];
      state.unities = [];
      state.list = [];
      state.outOfList = [];
      state.lowList = [];
      state.expiredList = [];
      state.stockMove = [];
    },

    
    removeProduct: (state, action) => {
      state.list = state.list.filter(
        (product) => product.id !== action.payload
      );
    },

    getstockMove: (state, action) => {
      state.stockMove = action.payload;
    },
  },
});

export const { getCategories, deleteCategory, getUnities,getProduct, deleteUnity, destroyProductData, getOutOfStock, getLowStock, getExpiredList, removeProduct, getstockMove } = productSlice.actions;
export default productSlice.reducer;
